export default {
  '检维修服务': [
    {
      'title': '点检服务',
      'imgUrl': 'static/img/服务图片/小图/点检.jpg',
      'childId': '0101',
      'content': '对DCS系统、SIS系统进行全面、深入的检测、保养和维护。'
    },
    {
      'title': '保修服务',
      'imgUrl': 'static/img/服务图片/小图/保修服务.jpg',
      'childId': '0102',
      'content': '中控保修服务产品是在超出基本保修期后仍可以享受原保修期内相关权益的服务，即延长质保期。'
    },
    {
      'title': '备件服务',
      'imgUrl': 'static/img/服务图片/小图/备件.jpg',
      'childId': '0103',
      'content': '为客户提供备件咨询、备件库支持、备件检测保养、备件销售、备件配置及备件相关现场服务。帮助企业用户最大程度地降低因备件问题而产生的停车风险。'
    },
    {
      'title': '定制服务',
      'imgUrl': 'static/img/服务图片/小图/定制服务.jpg',
      'childId': '0104',
      'content': '中控定制服务是根据用户个性化需求，专门设计并提供的服务项目，其特点为灵活、快速、定制化。'
    },
    {
      'title': '扩容服务',
      'imgUrl': 'static/img/服务图片/小图/扩容服务.jpg',
      'childId': '0105',
      'content': '中控扩容服务是为更好地满足用户生产需求，在原系统规模基础上，帮助用户增加（新上项目）控制系统的服务产品。'
    },
    {
      'title': '利旧服务',
      'imgUrl': 'static/img/服务图片/小图/利旧改造.jpg',
      'childId': '0106',
      'content': '利旧改造服务是指由于随同装置搬迁或者应用在其它装置上的需要，针对将旧的中控DCS系统的全部或部分部件进行搬迁或利用改造的过程，由中控专业服务工程师综合资产评估利用、系统安全防护、搬迁保养更新、工程设计与实施等方面因素提供整体解决方案。'
    },
    {
      'title': '年保服务',
      'imgUrl': 'static/img/服务图片/小图/年保服务.jpg',
      'childId': '0107',
      'content': '年保服务能够在指定期限内为用户提供快速的紧急保障、周期性的现场巡检及常规维护服务，包括能够为用户提供：定期现场巡检与常规维护；7*24小时紧急响应；紧急报修；配备专家小组等，并最终为系统稳定运行保驾护航。'
    },
    {
      'title': '升级服务',
      'imgUrl': 'static/img/服务图片/小图/升级.jpg',
      'childId': '0108',
      'content': '中控升级服务是指对已竣工项目系统的软、硬件进行升级的技术服务，以较少的投资提升系统品质'
    },
    {
      'title': '替换代升级服务',
      'imgUrl': 'static/img/服务图片/小图/替换代升级.jpg',
      'childId': '0109',
      'content': '基于数十年的大型控制系统工程项目实施经验积累，运用SUPCON WebField控制系统最新技术与产品，对老旧、超期服役或者处于产品生命周期末端的现场控制系统进行整体的全面更换、升级的专项定制服务。'
    },
    {
      'title': '维保服务',
      'imgUrl': 'static/img/服务图片/小图/维保.jpg',
      'childId': '0110',
      'content': '驻厂维保主要针对DCS、PLC以及SIS等流程工业控制系统，由专业维保服务工程师常驻于用户现场，提供7*24小时不间断的设备巡检、日常维护保养、故障处理、备件管理、设备报表与分析等专业系统维护服务。'
    },
    {
      'title': '组态优化服务',
      'imgUrl': 'static/img/服务图片/小图/组态优化.jpg',
      'childId': '0111',
      'content': '中控组态优化服务是在用户生产主装置不变的情况下，利用对已验收项目控制系统中的组态做优化，从而改进应用效果、提升操作体验的改造服务。'
    },
    {
      'title': '现场仪表校验服务',
      'imgUrl': 'static/img/服务图片/小图/现场仪表校验服务.jpg',
      'childId': '0201',
      'content': '通过一系列专业仪表器或官方认可的检测机构合作，对现场仪表中需要定期校验、校准、标定，甚至准确性检定等服务，为业主生产的稳定性提供保障。'
    },
    {
      'title': '分析仪器校验服务',
      'imgUrl': '',
      'childId': '0202',
      'content': '对现场使用中的分析仪定期检测、检验、标定，以确保各类分析仪输出数据的准确性。'
    },
    {
      'title': '仪器仪表运保服务',
      'imgUrl': 'static/img/服务图片/小图/仪器仪表运保服务.jpg',
      'childId': '0203',
      'content': '通过投运初期陪伴业主完成对自控系统的学习、熟悉、了解，从而有效提升生产效率和安全性，并可在整个生产周期对仪表运行情况的监测，陪伴业主对生产过程中仪表的表现、故障、工艺参数等定期或随叫随到式的保运服务。'
    }
  ],
  '培训服务': [
    {
      'title': '产品培训',
      'imgUrl': 'static/img/服务图片/小图/产品培训.jpg',
      'content': '凭借对完整的产品体系及流程工业的深刻理解, 从现场仪表到控制系统,从实时监控到先进控制,从过程信息管理到企业信息管理，中控产品培训课程涵盖中控集团“SUPCON”品牌所有系统产品，形成了集控制、优化、调度、管理、经营于一体的综合自动化培训新模式。',
      'childId': '0301'
    },
    {
      'title': '专题培训',
      'imgUrl': 'static/img/服务图片/小图/专题培训.jpg',
      'content': '面向不同客户需求，科学设计各种实用的、专业的、热点的、尖端的、前沿的专题培训，为自动化从业人员完善知识结构、提升管理及技术等方面的综合能力提供学习交流的平台，使之对相应专题进行系统的学习，并且可针对各类专题问题掌握解决问题的思路、方法及应对措施。',
      'childId': '0302'
    },
    {
      'title': '定制培训',
      'imgUrl': '',
      'content': '根据企业的培训需求，为企业量身定做培训解决方案, 具有培训内容、时间、地点等方面的充分灵活性，培训针对性强。',
      'childId': '0303'
    },
    {
      'title': '网络培训',
      'imgUrl': 'static/img/服务图片/小图/网络培训.jpg',
      'content': '基于互联网的普遍应用，中控培训推出高效、便利的网络课程，包含在线互动教学、课程视频点播等多种形式，把培训课堂搬到您的企业或家里，让您不出门即可享受专业的培训。',
      'childId': '0304'
    },
    {
      'title': '仿真培训',
      'imgUrl': 'static/img/服务图片/小图/仿真培训.jpg',
      'content': '培训中心配有各系列的仿真器或虚拟控制器，可进行教学演示、实现复杂程序的调试与练习。还建有OTS（即操作员培训仿真系统）实验室，逼真地模拟工厂的开停车、正常运行和各种事故过程的现象和操作，帮助企业提高操作员的知识水平和技术水平、缩短工厂开停车时间，，延长装置连续生产时间，提高安全性。',
      'childId': '0305'
    }
  ],
  '咨询设计服务': [
    {
      'title': '仪控抗干扰咨询服务',
      'imgUrl': '',
      'content': '从仪控设备的设计选型（包括产品原理性能品牌）、设备的布置及安装、电源及信号的连接、接地与屏蔽、使用环境及周边设备、日常维护等方面解答仪控设备的抗干扰问题',
      'childId': '0401'
    },
    {
      'title': '防雷咨询及设计服务',
      'imgUrl': '',
      'content': '为用户提供雷击风险评估，雷击事故分析，仪控系统防雷设计及施工，雷电防护咨询和培训，干扰源排查，仪控整体解决方案等业务。提升企业用户提升防雷及抗干扰能力。',
      'childId': '0402'
    },
    {
      'title': '智能工厂咨询服务',
      'imgUrl': '',
      'content': '对流程行业企业智能工厂整体建设开展顶层规划咨询服务，为企业全面实施智能工厂建设项目提供顶层规划方案和实施指导。',
      'childId': '0403'
    },
    {
      'title': '智慧园区咨询服务',
      'imgUrl': '',
      'content': '对工业园区管理运营单位（部门）实现园区智慧化管理运营开展顶层设计咨询服务，为实施“智慧园区”项目建设提供顶层设计方案和实施指导。',
      'childId': '0404'
    },
    {
      'title': '开车保运服务',
      'imgUrl': '',
      'content': '企业在新装置开车时，由中控专业团队对DCS、SIS、ITCC控制系统、安全栅柜、继电器柜、辅助接线柜、现场仪表阀门等进行开车保运及故障判断及处理。以保障装置正常开车的一种服务。',
      'childId': '0405'
    }
  ],
  '供应链代采服务': [
    {
      'title': '系统备件框架协议',
      'imgUrl': '',
      'content': '与长期合作或有意长期合作的业主签定备品仪表、系统备品备件的代采购框架协议，进而通过统一的代采购及中控自身的庞大用量及中控供应链的价格和速度优势，为客户提供更具性价比的备件服务。',
      'childId': '0501'
    },
    {
      'title': '仪控类代采购服务',
      'imgUrl': '',
      'content': '为客户提供仪控仪表的代采购业务，包括各类传感器、变送器、定制仪表和分析仪等。',
      'childId': '0502'
    },
    {
      'title': '电气类代采购服务',
      'imgUrl': '',
      'content': '为提供提供电气代采购服务，包括旧设备更换、维修、替代升级，电气图纸设计等。',
      'childId': '0503'
    }
  ]
}
